const StateInterface = {
    hasStackCombo(buildId, stackId, combo) {
        const combinations = this.getStackCombos(stackId);
        return combinations.hasOwnProperty(this.doComboId(combo));
    },
    getStackCombo(buildId, stackId, combo) {
        const combinations = this.getStackCombos(stackId);
        const comboId = this.doComboId(combo);
        if (combinations.hasOwnProperty(comboId)) {
            return combinations[comboId];
        }
        return null;
    },
    getStackCombos(stackId) {
        const usi = this.doUniqueStackId(stackId);
        if (this.data.hasOwnProperty(usi)) {
            return {...this.data[usi]};
        }
        return {};
    },
    all() {
        return cp(this.data);
    },
    doComboId(combination) {
        return combination.sort().join('');
    },
    doUniqueStackId(stackId) {
        return stackId;
    },
};

export default StateInterface;
